import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    wrapper: {
        paddingBottom: 20,
        backgroundColor:"white",
        borderRadius:"10px"
    },
    header: {
        padding: "10px 20px",
    },
    toolbar: {
        padding: "10px 20px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    crudButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    content: {
        padding: "10px 20px",
    },
    addButton: {
        maxHeight: 50
    },
    deleteButton: {
        position: 'absolute',
        top: -10,
        right: -12,
    },
    center: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    }
}));